var KEY_UNID = 'key_unid';

var unid = ''

function getUnid() {
	if (!isEmpty(unid)){
		return unid;
	}
	unid = localStorage.getItem(KEY_UNID);

	if (isEmpty(unid)) {
		unid = uuid();
		localStorage.setItem(KEY_UNID, unid)
	}
	return unid;
}

function setUnid(newUnid){
	unid = newUnid;
	localStorage.setItem(KEY_UNID, unid)
}

function getLocalData(key) {
	return localStorage.getItem(key);
}

function setLocalData(key, value){
	localStorage.setItem(key, value)
}


function uuid() {
	var s = [];
	var hexDigits = "0123456789abcdef";
	for (var i = 0; i < 36; i++) {
		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
	}
	s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
	s[8] = s[13] = s[18] = s[23] = "-";

	var uuid = s.join("");
	return uuid;
}

function isEmpty(str) {
	return str == null || str == undefined || str == '' || str == 'null';
}

function startWith(url, target){
	if(isEmpty(url)){
		return false;
	}
	
	return url.indexOf(target) == 0;
}

/**
 * 计算合并信息
 * @param {Array} data        表格源数据
 * @param {Array} mergeCols   需要合并的字段名数组，如 ['dept', 'name']
 * @returns {Object}          结构：{ dept: [2,0,1,…], name: [1,1,0,…] }
 */
function getSpanMap(data, mergeCols) {
  const spanMap = {}          // 每个字段对应一个 rowspan 数组
  mergeCols.forEach(col => spanMap[col] = [])

  let pos = 0                 // 当前比较起始位置
  while (pos < data.length) {
    mergeCols.forEach(col => {
      let sameCount = 1
      // 向后找相同值
      for (let i = pos + 1; i < data.length; i++) {
        if (data[i][col] === data[pos][col]) sameCount++
        else break
      }
      // 写入 rowspan：首格=sameCount，其余=0
      for (let i = 0; i < sameCount; i++) {
        spanMap[col][pos + i] = i === 0 ? sameCount : 0
      }
    })
    pos += spanMap[mergeCols[0]][pos] || 1 // 跳到下一组
  }
  return spanMap
}

function convertList2Map(list, key){
	let map = {}
	
	list.forEach(function(ele) {
		map[ele[key]] = ele;
	});
	
	return map;
}

// utils/tableMerge.js - 简化重写版

function createSpanMethod(tableData, mergeFields, allFields = [], fieldMapping = {}) {
  if (!tableData || tableData.length === 0) {
    return function() {
      return { rowspan: 1, colspan: 1 };
    };
  }

  // 构建合并映射
  const mergeMap = {};
  
  // 初始化所有字段
  const fields = allFields.length > 0 ? allFields : mergeFields;
  fields.forEach(field => {
    mergeMap[field] = [];
  });

  // 处理每个合并依据字段
  mergeFields.forEach((field, fieldIndex) => {
    let rowspan = 1;
    let startRow = 0;
    
    // 获取前置字段列表
    const prevFields = mergeFields.slice(0, fieldIndex);
    
    for (let i = 0; i < tableData.length; i++) {
      // 检查是否与上一行相同
      if (i > 0) {
        const currentValue = tableData[i][field];
        const prevValue = tableData[i - 1][field];
        
        // 检查前置字段是否也相同
        let prevFieldsSame = true;
        for (const prevField of prevFields) {
          if (tableData[i][prevField] !== tableData[i - 1][prevField]) {
            prevFieldsSame = false;
            break;
          }
        }
        
        // 如果当前字段值和前置字段值都相同，则合并
        if (currentValue === prevValue && prevFieldsSame) {
          rowspan++;
          // 标记当前行为隐藏
          mergeMap[field][i] = { rowspan: 0, hidden: true };
        } else {
          // 结束上一组
          if (rowspan > 1) {
            mergeMap[field][startRow] = { rowspan: rowspan, hidden: false };
          } else {
            mergeMap[field][startRow] = { rowspan: 1, hidden: false };
          }
          // 开始新组
          rowspan = 1;
          startRow = i;
          mergeMap[field][i] = { rowspan: 1, hidden: false };
        }
      } else {
        // 第一行
        mergeMap[field][i] = { rowspan: 1, hidden: false };
      }
    }
    
    // 处理最后一组
    if (rowspan > 1) {
      mergeMap[field][startRow] = { rowspan: rowspan, hidden: false };
    }
  });

  // 处理字段映射
  Object.keys(fieldMapping).forEach(targetField => {
    const sourceField = fieldMapping[targetField];
    if (mergeMap[sourceField] && mergeMap[targetField]) {
      for (let i = 0; i < tableData.length; i++) {
        const sourceInfo = mergeMap[sourceField][i];
        mergeMap[targetField][i] = {
          rowspan: sourceInfo.rowspan,
          hidden: sourceInfo.hidden
        };
      }
    }
  });

  // 返回 span-method 函数
  return function({ row, column, rowIndex, columnIndex }) {
    const field = column.property;
    
    // 如果该字段不在合并映射中，不合并
    if (!mergeMap[field]) {
      return { rowspan: 1, colspan: 1 };
    }
    
    const info = mergeMap[field][rowIndex];
    if (!info) {
      return { rowspan: 1, colspan: 1 };
    }
    
    if (info.hidden) {
      return { rowspan: 0, colspan: 0 };
    }
    
    return {
      rowspan: info.rowspan,
      colspan: 1
    };
  };
}

module.exports = {
	getUnid,
	setUnid,
	getLocalData,
	setLocalData,
	isEmpty,
	startWith,
	getSpanMap,
	convertList2Map,
	createSpanMethod
}
